import React from 'react';

interface ITopArrowProps {
	className?: string,
	onClick?: () => void
}

export const TopArrow = ({ className, onClick }: ITopArrowProps) => (
	<svg
		width="14"
		height="20"
		viewBox="0 0 14 20"
		fill="white"
		xmlns="http://www.w3.org/2000/svg"
		className={className}
		onClick={onClick}
	>
		<path d="M8.00005 3.825L8.00005 19C8.00005 19.2833 7.90422 19.5208 7.71255 19.7125C7.52088 19.9042 7.28338 20 7.00005 20C6.71672 20 6.47922 19.9042 6.28755 19.7125C6.09588 19.5208 6.00005 19.2833 6.00005 19L6.00005 3.825L2.10005 7.7C1.91672 7.88333 1.68755 7.97917 1.41255 7.9875C1.13755 7.99583 0.900048 7.9 0.700048 7.7C0.516715 7.51667 0.425048 7.28333 0.425048 7C0.425048 6.71667 0.516715 6.48333 0.700048 6.3L6.30005 0.699999C6.40005 0.599998 6.50838 0.529165 6.62505 0.487499C6.74172 0.445833 6.86672 0.424999 7.00005 0.424999C7.13338 0.424999 7.25838 0.445833 7.37505 0.487499C7.49172 0.529165 7.60005 0.599998 7.70005 0.699999L13.3 6.3C13.4834 6.48333 13.575 6.7125 13.575 6.9875C13.575 7.2625 13.4834 7.5 13.3 7.7C13.1 7.9 12.8625 8 12.5875 8C12.3125 8 12.075 7.9 11.875 7.7L8.00005 3.825Z" />
	</svg>
);
